import React from "react"
import { Script } from "gatsby"
import Layout from "./src/components/Layout.tsx"

export const wrapPageElement = ({ element, props }) => {
  return (
    <>
      <Layout {...props}>
        {element}
      </Layout>
      <Script
        src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      />
      <Script
        src="/livechat.js"
      />
      <Script
        src="//lite.calltracks.com/wnd/loader.js?force_tracking=1"
      />
    </>
  );
}
